import { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  content: {
    padding: theme.spacing(2),
  },
}));

export interface ScaffolderFormPaperProps {
  children: ReactNode;
}

/** The raised surface every DaaS scaffolder field is laid out on. */
export const ScaffolderFormPaper = ({ children }: ScaffolderFormPaperProps) => {
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.container}>
      <Paper variant={theme.palette.mode === 'dark' ? 'outlined' : 'elevation'}>
        <Box className={classes.content}>{children}</Box>
      </Paper>
    </Box>
  );
};
